var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTime),expression:"showTime"}]},[_vm._v(_vm._s(_vm.useTime)+"s")])}
var staticRenderFns = []

export { render, staticRenderFns }